import styled from 'styled-components'
import { Tokens } from '@/assets/tokens'

export const WideFormContainer = styled.form<{ $fullHeight?: boolean; $shouldExpand?: boolean }>`
  all: unset;
  border-radius: 20px;
  padding: 2rem;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  gap: 20px;

  background-color: ${Tokens.ColorWhite};

  box-sizing: border-box;
  width: 100%;

  ${({ $fullHeight, $shouldExpand }) =>
    $fullHeight &&
    $shouldExpand &&
    `
    flex: 1;
    min-height: 0;
    height: auto;
    max-height: none;
  `}

  ${({ $fullHeight, $shouldExpand }) =>
    $fullHeight &&
    !$shouldExpand &&
    `
    height: auto;
    min-height: auto;
  `}

  h1 {
    font-size: 24px;
    font-weight: 600;
  }

  @media (max-width: 768px) {
    padding: 1.5rem;
    gap: 16px;
  }

  @media (max-width: 480px) {
    padding: 1rem;
    gap: 12px;
  }
`

export const WideFormContent = styled.div<{ $fullHeight?: boolean; $shouldExpand?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;

  ${({ $fullHeight, $shouldExpand }) =>
    $fullHeight &&
    $shouldExpand &&
    `
    flex: 1;
    min-height: 0;
    height: auto;
    overflow-y: auto;
    overflow-x: hidden;
  `}
`
